<template>
  <div class="row">
    <form @submit.prevent="npiSearchForm">
      <div class="col-sm-8 col-sm-offset-2">
        <div class="form-group">
          <label for="npi_number">Search by NPI Number:</label>
          <input
            id="npi_number"
            v-model="npi_number"
            type="text"
            name="npi_number"
            class="form-control"
          />
        </div>
        <form-or-message></form-or-message><br />
        <div v-if="currentFormType === 'personal'" id="person" class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label for="npi_first_name">First Name:</label>
              <input
                id="npi_first_name"
                v-model="npi_first_name"
                type="text"
                name="npi_first_name"
                class="form-control"
              />
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label for="npi_last_name">Last Name:</label>
              <input
                id="npi_last_name"
                v-model="npi_last_name"
                type="text"
                name="npi_last_name"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div
            v-if="currentFormType === 'business'"
            id="organization"
            class="col-sm-6"
          >
            <div class="form-group">
              <label for="npi_company">Organization Name:</label>
              <input
                id="npi_company"
                v-model="npi_company"
                type="text"
                name="npi_company"
                class="form-control"
              />
            </div>
          </div>
          <div id="city" class="col-sm-6">
            <div class="form-group">
              <label for="npi_city">City:</label>
              <input
                id="npi_city"
                v-model="npi_city"
                type="text"
                name="npi_city"
                class="form-control"
              />
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label for="npi_state">State:</label>
              <select
                id="npi_state"
                v-model="npi_state"
                name="npi_state"
                class="form-control"
              >
                <option value="">Please select</option>
                <option
                  v-for="(state, index) in states"
                  :key="'state_' + state"
                  :value="index"
                >
                  {{ state }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label for="npi_postal_code">Postal Code:</label>
              <input
                id="npi_postal_code"
                v-model="npi_postal_code"
                type="text"
                name="npi_postal_code"
                class="form-control"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <button id="btn-lookup" class="btn btn-info">Search</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import states from "../../../usa_states.json";
import FormOrMessage from "./elements/FormOrMessage.vue";

export default {
  components: {
    FormOrMessage,
  },
  data() {
    return {
      npi_number: "",
      npi_first_name: "",
      npi_last_name: "",
      npi_company: "",
      npi_city: "",
      npi_state: "",
      npi_postal_code: "",
      errors: [],
      states,
    };
  },
  computed: {
    currentFormType() {
      return this.$store.state.registration.type;
    },
  },
  methods: {
    npiSearchForm() {
      const formFields = this.getFormFields();
      this.$store.dispatch("getNpiRecords", formFields);
    },
    getFormFields() {
      return {
        npi_number: this.npi_number.trim(),
        npi_company: this.npi_company.trim(),
        npi_city: this.npi_city.trim(),
        npi_state: this.npi_state.trim(),
        npi_postal_code: this.npi_postal_code.trim(),
        npi_first_name: this.npi_first_name.trim(),
        npi_last_name: this.npi_last_name.trim(),
      };
    },
  },
};
</script>
